import { type RootContainerProps } from "@client/content/types";
import { eventIdSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import { connect } from "react-redux";
import { fetchPage } from "../actions";
import {
  localStateSelector,
  makeCategoryIdSelector,
  makeFilterOrderBySelector,
  makeFilterPageSizeSelector,
  makeGridListPropsSelector
} from "../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  const gridPropsSelector = makeGridListPropsSelector();
  const categoryIdSelector = makeCategoryIdSelector();
  const orderSelector = makeFilterOrderBySelector();
  const pageSizeSelector = makeFilterPageSizeSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      categoryId: categoryIdSelector(state, props),
      eventId: eventIdSelector(state),
      gridProps: gridPropsSelector(state, props),
      hasProducts: localState.hasProducts,
      order: orderSelector(state, props),
      pageSize: pageSizeSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  load: (page: number) => dispatch(fetchPage({ id: props.id, source: props.source, page }))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
